import { render } from "./arrayImage.vue?vue&type=template&id=2f778a30&scoped=true"
import script from "./arrayImage.vue?vue&type=script&lang=js"
export * from "./arrayImage.vue?vue&type=script&lang=js"

import "./arrayImage.vue?vue&type=style&index=0&id=2f778a30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f778a30"]])

export default __exports__